/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_RemovedInputs */

const en_serve_removed = /** @type {(inputs: Serve_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computer removed.`)
};

const id_serve_removed = /** @type {(inputs: Serve_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komputer dihapus.`)
};

/**
* | output |
* | --- |
* | "Computer removed." |
*
* @param {Serve_RemovedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_removed = /** @type {((inputs?: Serve_RemovedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_RemovedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_removed(inputs)
	return en_serve_removed(inputs)
});